


































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import AppConsts from '@/lib/appconst';
import _ from 'lodash';    
import expandRow from './inbound-exception-expand.vue';
import ViewPoLineException from '../../store/entities/inbound-exceptions/view-po-line-exceptions'
import PoLineException from '../../store/entities/inbound-exceptions/po-line-exception'
import PoExceptions from '../../store/entities/inbound-exceptions/po-exceptions'
import ProductForSelect from '@/store/entities/products/product-for-select'
class  PageInboundExceptionRequest extends PageRequest{
    keyword:string;
}

@Component({
  components:{ expandRow }
})
export default class InboundException extends AbpBase{
    @Prop({ type: Number, default: 0}) refId: number;
    @Prop({ type: String, default: "" }) refTypeCode: string;
    @Prop({ type: Boolean, default: false }) declareOverShort: boolean;
    @Prop({ type: Number, default: 0 }) poId: number;
    @Prop({ type: Object, default: new PoExceptions }) poExceptions: PoExceptions;
   
    //filters
    pagerequest:PageInboundExceptionRequest=new PageInboundExceptionRequest();
    exceptionSku:string='';
    exceptionProductName :string='';
    exceptionProductId :number=0;
    exceptionQty:number=1;
    exceptionNote:string='';
    exceptionType:string='';
    filterPoLineExceptions :Array<ViewPoLineException> =Array<ViewPoLineException>();
    exceptionTypes : Array<any>=[];
    objectLoading :boolean=false;
    products : Array<ProductForSelect> = new Array<ProductForSelect>();
    searchProduct_OnPress =   _.debounce(this.searchProductForSelect, AppConsts.debounceDelayTime, {
        leading: false,
        trailing: true,
    });
    get store(){
        return this.$store.state.inboundException;
    }
    isClient() {
      return this.$store.state.session.client != null;
    }
    isTenant() {
      return this.$store.state.session.tenant!=null;
    }
    hasDeclarePermission()
    {
        return this.hasPermission('Operations.PurchaseOrders.DeclareOverShortQty');
    }
    get loading(){
        return this.$store.state.inboundException.loading;
    }
    showEdit(row:any,index:number)
    {
        if(row.showEdit==='invisibleInput')
        {
            row.showEdit='visibleInput';
        }
    }
    showButtonEdit(row:any,index:number)
    {
        if(row.showEdit==='invisibleInput')
        {
            return false;
        }
        return true;
    }
    async searchProductForSelect(keyword)
    {
        if(Util.isEmpty(keyword) || keyword.length<AppConsts.keyWordAtleastLength)
            return;
        this.objectLoading= true;
        this.products = await this.$store.dispatch({
                type:'purchaseOrder/searchPoProductForSelect',
                data: {
                    poId:this.poId,
                    keyWord:keyword
                }
        });
        this.objectLoading= false;
    }
    changeProduct()
    {
        if (Util.isNull(this.exceptionSku) || Util.isEmpty(this.exceptionSku)) {
            this.exceptionProductName = '';
            this.exceptionProductId = 0;
            return;
        } 
        var product = _.find(this.products,['sku', this.exceptionSku]);
        if(Util.isNull(product))
        {
            this.exceptionProductName='';
            this.exceptionProductId = 0;
            Util.showErrorMsg(this,"Error.ProductNotExist");
            return;
        }
        this.exceptionProductName= product.name;
        this.exceptionProductId = product.id;
    }
    async addException(){
       var validData =this.checkAddData();
       if(validData)
       {
           var product = await this.checkProduct();
            if(!Util.isNull(product))
            {
                var item = new PoLineException();
                item = {
                        poId :this.poId,
                        poLineNumber:0,
                        qty: this.exceptionQty,
                        note : this.exceptionNote,
                        type : this.exceptionType,
                        creationTime: new Date(),
                        typeName:'',
                        creatorUserName:'',
                        operator:''
                };
                var exceptionType = this.exceptionType;
                var typeObj = this.exceptionTypes.find(function(element) {
                    return element.code === exceptionType;
                });
                var exceptionTypeName = typeObj.description;
                var newLine = new ViewPoLineException();
                newLine = {
                    id:0,
                    sku : this.exceptionSku,
                    productName: this.exceptionProductName,
                    productId: product.productId,
                    exceptionQty: this.exceptionQty,
                    exceptionType : this.exceptionType,
                    orderQty: product.orderQty,
                    shortQty : product.shortQty,
                    editQty: this.exceptionQty,
                    exceptionTypeName:exceptionTypeName,
                    showEdit:'invisibleInput',
                    items:[item]
                };
                
                this.poExceptions.items.unshift(newLine);
                this.getpage();
                this.exceptionSku="";
                this.exceptionQty=1;
                this.exceptionNote ="";
            }
       }
    }
    async checkProduct()
    {
        var items = this.poExceptions.items;
        var existedItems =items.filter((item) => item.sku==this.exceptionSku && item.exceptionType== this.exceptionType);;
        if(existedItems.length>0)
        {
               Util.showErrorMsg(this,"Error.SkuExisted");
               return null;
        }
        else
        {
            var product = await this.$store.dispatch({
            type:'inboundException/checkProductInfo',
            data:{
                poId: this.poId,
                productId:this.exceptionProductId,
                qty:this.exceptionQty
            }
            });
            return product;
        }
        return null;
    }
    checkAddData(){
        if(Util.isNull(this.exceptionSku) || Util.isEmpty(this.exceptionSku) || Util.isNull(this.exceptionProductId) || this.exceptionProductId<=0)
        {
            Util.showErrorMsg(this,"Error.SkuRequired");
            return false;
        }
        if(Util.isNull(this.exceptionType) || Util.isEmpty(this.exceptionType))
        {
            Util.showErrorMsg(this,"Error.TypeIsRequired");
            return false;
        }
        if(Util.isNull(this.exceptionQty) || this.exceptionQty<=0)
        {
            Util.showErrorMsg(this,"Error.QtyMustGreaterThanZero");
            return false;
        }
        return true;
    }
    checkEditQty(row:any,index:number)
    {
        var item = row;
        var editQty = row.editQty;
        if(row.id==0 )
        {
            if(editQty > row.shortQty)
            {
                row.editQty = row.exceptionQty;
                row.items[0].qty = row.exceptionQty;
                return false;
            }
           row.items[0].qty = editQty;
        }
        if(row.id>0 && editQty > row.shortQty+row.exceptionQty)
        {
            row.editQty = row.exceptionQty;
            return false;
        }
        this.filterPoLineExceptions[index].editQty = editQty;
        this.filterPoLineExceptions[index].showEdit="visibleInput";
        var exceptionIndex = Util.indexWhere(this.poExceptions.items, item=> item.productId== row.productId && item.exceptionType== row.exceptionType);
        this.poExceptions.items[exceptionIndex].editQty=editQty;
         this.poExceptions.items[exceptionIndex].showEdit="visibleInput";
        return true;
    }
    getDataToSave()
    {
        var items = this.poExceptions.items.map(function(i) {
               return {
                    'ProductId': i.productId,
                'Qty': i.editQty,
                'Note': i.items[0].note,
                'Type': i.exceptionType
               };
            });
        return {
            refId: this.refId,
            refTypeCode: this.refTypeCode,
            poId: this.poId,
            items : items
        };
    }
    async saveExceptions()
    {
        this.$Modal.confirm({
            title:this.L('Tips'),
            content:this.L('Confirm.SavePurchaseOrderExceptions'),
            okText:this.L('Yes'),
            cancelText:this.L('No'),
            onOk:async()=>{
                 var data = this.getDataToSave();
                await this.$store.dispatch({
                    type: "inboundException/create",
                    data: data
                    }) 
                    .then(result => {
                    Util.showSuccessMsg(this,"Success.SavePurchaseOrderExceptions");
                    
                });
                await this.getPOExceptions();
            }
        });
    }
    async getPOExceptions()
    {
        if(!Util.isNull(this.refId) && this.refId>0)
        {
            await this.$store.dispatch({
            type:'inboundException/getAll',
            data:{
                refId: this.refId,
                refTypeCode: this.refTypeCode
            }
            });
            this.poExceptions.items = this.store.list;
        }
    }
    getpage(){
        var items =this.poExceptions.items ;
        if (!Util.isNull(this.pagerequest.keyword) && !Util.isEmpty(this.pagerequest.keyword)) {
             var keyWord = this.pagerequest.keyword.toLowerCase(); 
             items = items.filter((item) => item.sku.toLowerCase().indexOf(keyWord) >= 0);
        } 
        this.filterPoLineExceptions = items;
    }
    
    columns = [
                    {
                        type: 'expand',
                        width: 50,
                        render: (h, params) => {
                            return h(expandRow, {
                                props: {
                                    row: params.row
                                }
                            }   )
                    
                        }
                    },
                    {
                        title: Util.L('SKU'),
                        key: 'sku'
                    },
                    {
                        title: Util.L('ProductName'),
                        key: 'productName'
                    },
                    {
                        title: Util.L('Type'),
                        key: 'exceptionTypeName'
                    },
                    {
                        title: Util.L('Qty'),
                        key: 'exceptionQty',
                        align:'right',
                        render: (h, params) => {
                                    return h("span", Util.toViewNumberString(params.row.exceptionQty))
                        }
                    },
                    {
                        title: Util.L('Edit'),
                        slot: 'action',
                        align: 'center'
                    }
            ]

    async created(){
        await this.$store.dispatch({
            type:'ref/getCommonRefsForSelect',
            data:{
                tableName: AppConsts.tableRef.tablePoLineException.name,
                columnName: AppConsts.tableRef.tablePoLineException.column.type
            }
        }).then(response=>{
            this.exceptionTypes = response;
        });
        if(!Util.isNull(this.exceptionTypes) && this.exceptionTypes.length>0)
        {
            this.exceptionType = this.exceptionTypes[0].code;
        }
        if(_.isNull(this.poExceptions))
        {
            this.poExceptions = new PoExceptions();
        }
    }
}
